import React from 'react';
import styled from 'styled-components';
import { Container, Text } from '../styles/components';
import { CowPattern } from './CowPattern';

const Section = styled.section`
  position: relative;
  overflow: hidden;
  background: transparent;
`;

const SectionContainer = styled(Container)`
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  position: relative;
  padding: 0;
`;

const BorderWrapper = styled.div`
  position: relative;
  padding: 0.45rem;
  background: ${props => props.theme.colors.background};
  border: ${props => props.theme.borders.widths.thin} solid ${props => props.theme.colors.secondary};
  border-radius: ${props => props.theme.radii.sm};
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('/assets/patterns/cow-pattern-border.svg') repeat;
    background-size: 120px;
    opacity: 1;
    pointer-events: none;
    inset: 0;
    -webkit-mask: 
      linear-gradient(to right, 
        black 0.45rem,
        black calc(100% - 0.45rem)
      )
      linear-gradient(to bottom, 
        black 0.45rem,
        black calc(100% - 0.45rem)
      );
    -webkit-mask-composite: intersect;
    mask-composite: intersect;
  }
`;

const ContentWrapper = styled.div`
  background: ${props => props.theme.colors.background};
  border-radius: ${props => props.theme.radii.sm};
  padding: 40px 0;
  overflow: hidden;
  border: ${props => props.theme.borders.widths.thin} solid ${props => props.theme.colors.secondary};
  position: relative;
`;

const ContentInner = styled.div`
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.containerPadding};
`;

const Title = styled(Text)`
  color: ${props => props.theme.colors.secondary};
  font-weight: 500;
  font-size: 1rem;
  font-family: ${props => props.theme.typography.heading.fontFamily};
  margin-bottom: 40px;
  text-align: center;
`;

const MarqueeWrapper = styled.div`
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  
  &::before,
  &::after {
    position: absolute;
    top: 0;
    width: 100px;
    height: 100%;
    content: "";
    z-index: 2;
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, white 0%, transparent 100%);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, white 0%, transparent 100%);
  }
`;

const MarqueeContent = styled.div`
  display: inline-block;
  white-space: nowrap;
  animation: marquee 40s linear infinite;

  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

const AudienceItem = styled.span`
  font-family: ${props => props.theme.typography.heading.fontFamily};
  font-size: 1.4rem;
  color: ${props => props.theme.colors.text};
  padding: 0 24px;
  display: inline-block;
`;

const AudienceSection = () => {
  const audiences = [
    'Founders',
    'Owners',
    'Solopreneurs',
    'OBMs',
    'Digital marketers',
    'CMOs',
    'Brand strategists',
    'CEOs',
    'Consultants'
  ];

  // Double the array to ensure smooth looping
  const doubledAudiences = [...audiences, ...audiences];

  return (
    <Section>
      <SectionContainer>
        <BorderWrapper>
          <ContentWrapper>
            <ContentInner>
              <Title>Designed for small but mighty businesses</Title>
              <MarqueeWrapper>
                <MarqueeContent>
                  {doubledAudiences.map((audience, index) => (
                    <AudienceItem key={index}>
                      {audience}
                    </AudienceItem>
                  ))}
                </MarqueeContent>
              </MarqueeWrapper>
            </ContentInner>
          </ContentWrapper>
        </BorderWrapper>
      </SectionContainer>
    </Section>
  );
};

export default AudienceSection; 